<template>
  <div class="col-span-3 flex flex-col">
    <slot />

    <div class="flex flex-col lg:flex-row items-start gap-5 lg:gap-4 no-scrollbar">
      <a :href="phoenixFundamentals[0].video_url" class="flex flex-col w-full lg:flex-1">
        <div class="relative rounded-lg overflow-hidden h-[358px] lg:min-w-[160px]">
          <img
            :src="phoenixFundamentals[0].image"
            :alt="phoenixFundamentals[0].title"
            class="w-full h-full object-cover"
          />
          <div class="absolute top-3 left-3 bg-primary-6 rounded-lg py-2">
            <IconPHXLogo class="h-7 text-white" />
          </div>
          <div class="absolute inset-0 flex items-center justify-center">
            <div class="w-12 h-12 rounded-full bg-white flex items-center justify-center">
              <svg class="w-5 h-5 ml-0.5" viewBox="0 0 24 24" fill="black">
                <polygon points="6,3 21,12 6,21" />
              </svg>
            </div>
          </div>
          <div
            class="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/60 to-transparent"
          >
            <h4 class="text-white font-semibold text-[32px] lg:text-xl leading-8 lg:leading-5">
              {{ phoenixFundamentals[0].title }}
            </h4>
          </div>
        </div>
      </a>

      <a
        v-for="item in phoenixFundamentals.slice(1)"
        :key="item.title"
        :href="item.video_url"
        class="flex flex-col gap-3 w-full lg:flex-1 lg:min-w-[160px]"
      >
        <div class="rounded-lg overflow-hidden h-[300px]">
          <img :src="item.image" :alt="item.title" class="w-full h-full object-cover" />
        </div>
        <div>
          <p v-if="item.subtext" class="text-xs lg:text-sm text-strong font-medium font-inter">
            {{ item.subtext }}
          </p>
          <h4 class="text-xl lg:text-sm font-semibold font-inter text-strongest lg:mt-1">
            {{ item.title }}
          </h4>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup>
import IconPHXLogo from "@/components/icons/IconPHXLogo.vue";

import phx_q3 from "@/assets/images/newsfeed_q3.png";
import phx_oil from "@/assets/images/newsfeed_oil.png";
import phx_nyc_se from "@/assets/images/newsfeed_nyc_se.png";
import phx_all_offerings from "@/assets/images/newsfeed_all_offerings.png";

const phoenixFundamentals = [
  { type: "video", video_url: "#", image: phx_oil, title: "Take Flight with Phoenix Energy" },
  { type: "standard", video_url: "#", image: phx_q3, title: "Earning Report", subtext: "Q3 2025" },
  {
    type: "standard",
    video_url: "#",
    image: phx_all_offerings,
    title: "All our offerings",
    subtext: "Phoenix Fundamentals",
  },
  {
    type: "standard",
    video_url: "#",
    image: phx_nyc_se,
    title: "Meet the team",
    subtext: "Phoenix Fundamentals",
  },
];
</script>
